// Test IDs for the patient profile (PatientDetail) — see ./index.js.

// "Edit details" on the patient card and its dialog.
export const PATIENT_EDIT = {
	openButton: 'patient-edit-open-button',
	dialog: 'patient-edit-dialog',
	nameInput: 'patient-edit-name-input',
	genderSelect: 'patient-edit-gender-select',
	ageModeDob: 'patient-edit-age-mode-dob',
	ageModeAge: 'patient-edit-age-mode-age',
	dobInput: 'patient-edit-dob-input',
	ageInput: 'patient-edit-age-input',
	bloodGroupSelect: 'patient-edit-blood-group-select',
	emailInput: 'patient-edit-email-input',
	cityInput: 'patient-edit-city-input',
	addressInput: 'patient-edit-address-input',
	pincodeInput: 'patient-edit-pincode-input',
	occupationInput: 'patient-edit-occupation-input',
	languageInput: 'patient-edit-language-input',
	referredByInput: 'patient-edit-referred-by-input',
	currentMobile: 'patient-edit-current-mobile',
	newMobileInput: 'patient-edit-new-mobile-input',
	cancelButton: 'patient-edit-cancel-button',
	saveButton: 'patient-edit-save-button',
};
